export const all = ['search'] as const
export const place = [...all, 'place'] as const
export const placeByCoordinates = (lat: number, lng: number) => [
  ...place,
  'coordinates',
  { lat, lng },
]
export const placeById = (id: string) => [...place, 'id', { id }]
